export const createSlug = (value: string) => {
  const slug = value.toLowerCase().replace(/#/g, '').split(' ').join('-');
  return slug;
};
